<template>
  <NuxtLink
    class="cursor-pointer text-primary-400 transition-colors duration-200 ease-in-out hover:text-primary-100"
    v-bind="{ ...$props, ...$attrs }"
  >
    <slot></slot>
  </NuxtLink>
</template>
